import styled from "@emotion/styled"
import { Dialog } from "@mui/material"

export const ProductGatesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .new-gate-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    min-height: 40px;
    padding: 8px 16px;
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
    padding: 14px;
  }

  .filters-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;

    .search-field {
      min-width: min(280px, 100%);
      flex: 1 1 220px;
    }

    .status-filter {
      min-width: 200px;
      flex: 0 1 220px;
    }

    .status-chips {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
    }

    .filter-meta {
      margin-left: auto;
      color: var(--cms-text-secondary);
      font-size: 12px;
      font-weight: 600;
    }

    .MuiButton-root {
      text-transform: none;
      font-weight: 700;
      border-radius: 9px;
      min-height: 40px;
    }
  }

  .page-empty {
    border: 1px dashed var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    padding: 26px 16px;
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
  }

  .table-shell .MuiTableContainer-root {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
  }

  .table-shell .MuiTableCell-head {
    background: var(--cms-table-head-bg);
    color: var(--cms-text-primary);
    font-weight: 700;
    font-size: 12px;
    border-bottom: 1px solid var(--cms-border);
  }

  .table-shell .MuiTableCell-body {
    font-size: 13px;
    color: var(--cms-text-primary);
    border-bottom: 1px solid var(--cms-border);
    vertical-align: top;
  }

  .status-chip {
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    padding: 2px 8px;
  }

  .status-chip.active {
    color: #166534;
    background: #dcfce7;
  }

  .status-chip.inactive {
    color: #b91c1c;
    background: #fee2e2;
  }

  .table-actions {
    display: flex;
    gap: 8px;
    justify-content: flex-end;

    .MuiButton-root {
      text-transform: none;
      border-radius: 9px;
      min-height: 34px;
      font-weight: 700;
      padding: 4px 10px;
    }
  }

  .table-empty {
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    padding: 18px;
  }

  .checkout-url {
    max-width: 420px;
    word-break: break-word;
  }

  .muted {
    color: var(--cms-text-secondary);
    opacity: 1;
    font-size: 12px;
    font-weight: 600;
  }
`

export const StyledProductGateDialog = styled(Dialog)`
  .MuiPaper-root {
    width: min(720px, calc(100vw - 28px));
    max-width: none;
    border-radius: 18px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 24px 48px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 18px 22px 8px;
  }

  .MuiDialogContent-root {
    padding: 10px 22px 10px;
  }

  .MuiDialogActions-root {
    padding: 8px 22px 18px;
    gap: 10px;
  }

  .dialog-title-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dialog-title {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .dialog-cancel-btn,
  .dialog-submit-btn {
    text-transform: none;
    border-radius: 10px;
    min-height: 40px;
    font-weight: 700;
    padding: 8px 14px;
  }

  .dialog-submit-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .MuiFormControl-root {
    margin: 0 0 14px;
    width: 100%;
  }
`

